export default function PHP_defined() {
  return (
    <div>
      <h1>PHP_defined</h1>
    </div>
  );
}
